import { createClient } from "@refinedev/supabase";
import { dataProvider as supabaseDataProvider } from "@refinedev/supabase";
import { RestDataProvider } from "./provider.js";
import dataProvider from "@refinedev/simple-rest";

const DATA_SOURCE = import.meta.env.VITE_DATA_SOURCE;
let data_provider = dataProvider("https://api.finefoods.refine.dev");

if (DATA_SOURCE === "supabase") {
  const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
  const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_KEY;
  const SUPABASE_SCHEMA = import.meta.env.VITE_SUPABASE_SCHEMA;
  const supabaseClient: any = createClient(SUPABASE_URL, SUPABASE_KEY, {
    db: {
      schema: SUPABASE_SCHEMA,
    },
    auth: {
      persistSession: true,
    },
  });
  data_provider = supabaseDataProvider(supabaseClient);
} else if (DATA_SOURCE === "rest") {
  data_provider = RestDataProvider(import.meta.env.VITE_REST_API_URL)
} else if (DATA_SOURCE === "zuplo") {
  data_provider = RestDataProvider(import.meta.env.VITE_ZUPLO_API_URL)
}

export const API_URL = import.meta.env.VITE_DATA_SOURCE === "rest" ? import.meta.env.VITE_REST_API_URL : import.meta.env.VITE_DATA_SOURCE === "zuplo" ? import.meta.env.VITE_ZUPLO_API_URL : import.meta.env.VITE_DATA_SOURCE === "supabase" ? import.meta.env.VITE_SUPABASE_URL : "";


export { data_provider };
